import { Link } from "react-router-dom";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import { PageShell, ShellSection } from "./PageShell";
import { StatusBadge } from "../components/common";
import { Reveal } from "../components/Reveal";
import { BUD } from "../data/content";
import { usePageMeta } from "../hooks/usePageMeta";

export default function BudPage() {
    const b = BUD;
    usePageMeta("Bud's Market Intelligence Desk — WarRoom Labs | Titan Haven Group LLC", b.intro, {
        image: "/assets/products/bud-open-desk.jpg",
    });
    return (
        <PageShell testId="bud-page" overline={b.overline} title={b.title} lede={b.intro}>
            <ShellSection>
                <Reveal className="flex flex-wrap items-center gap-3">
                    <StatusBadge testId="bud-status">{b.status}</StatusBadge>
                    <span className="text-xs tracking-[0.15em] uppercase text-thg-tertiary">{b.relationship}</span>
                </Reveal>
                <Reveal delay={0.1} className="mt-10">
                    <div className="border border-thg-border" data-testid="bud-gallery">
                        <img
                            src="/assets/products/bud-open-desk.jpg"
                            alt="Bud's Market Intelligence Desk — historical interface capture; not the current live UI. The current product is the Bud Basket v2.6 at bud.titanhavengroup.com"
                            className="w-full h-auto"
                            loading="lazy"
                        />
                    </div>
                    <p className="mt-3 text-[10px] tracking-[0.2em] uppercase text-thg-tertiary">
                        Historical interface capture — not the current live UI. Current status: bud.titanhavengroup.com
                    </p>
                </Reveal>
            </ShellSection>
            <ShellSection>
                <Reveal>
                    <a
                        href={b.externalUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="bud-open-product-cta"
                        className="inline-flex items-center gap-2 bg-thg-red text-white hover:bg-thg-redhover transition-colors duration-300 px-6 py-3 text-sm tracking-wide uppercase"
                    >
                        Open the live product <ArrowUpRight size={16} />
                    </a>
                    <p className="mt-5 text-sm text-thg-secondary">
                        Product website:{" "}
                        <a
                            href={b.externalUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="bud-product-link"
                            className="text-white underline decoration-thg-red underline-offset-4 hover:text-thg-secondary transition-colors duration-300"
                        >
                            Bud&rsquo;s Market Intelligence Desk — bud.titanhavengroup.com
                        </a>
                    </p>
                </Reveal>
            </ShellSection>
            {b.sections.map((s) => (
                <ShellSection key={s.heading}>
                    <Reveal>
                        <h2 className="font-display text-2xl md:text-3xl font-medium text-white">{s.heading}</h2>
                        <p className="mt-4 text-sm md:text-base leading-relaxed text-thg-secondary max-w-3xl">{s.text}</p>
                    </Reveal>
                </ShellSection>
            ))}
            <ShellSection>
                <Reveal className="flex flex-wrap items-center gap-6">
                    <Link
                        to="/warroom"
                        data-testid="bud-back-warroom"
                        className="inline-flex items-center gap-2 text-sm text-thg-secondary hover:text-white transition-colors duration-300"
                    >
                        <ArrowLeft size={15} /> WarRoom Labs
                    </Link>
                    <Link
                        to="/portfolio"
                        data-testid="bud-back-portfolio"
                        className="inline-flex items-center gap-2 text-sm text-thg-secondary hover:text-white transition-colors duration-300"
                    >
                        <ArrowLeft size={15} /> Back to portfolio
                    </Link>
                </Reveal>
            </ShellSection>
        </PageShell>
    );
}
